import { useState } from "react";
import { useWaitlist } from "../hooks/useWaitlistForm";
import { Button } from "./Button";

export function PostSubmitPanel() {
  const { followupStatus, submitFollowup, error } = useWaitlist();
  const [text, setText] = useState("");
  const [skipped, setSkipped] = useState(false);

  if (followupStatus === "submitted" || skipped) {
    return (
      <div className="post-submit">
        <div className="post-submit__done">
          <span className="post-submit__done-dot" aria-hidden="true" />
          <span>You're on the list. We'll be in touch.</span>
        </div>
      </div>
    );
  }

  const submitting = followupStatus === "submitting";

  return (
    <form
      className="post-submit"
      onSubmit={(e) => {
        e.preventDefault();
        if (text.trim().length === 0) return;
        void submitFollowup(text.trim());
      }}
    >
      <div className="post-submit__head">
        <span className="post-submit__title">Thanks. One last thing — totally optional.</span>
        <span className="post-submit__sub">
          How do you currently run technical interviews for niche roles? What's the part you're most
          unhappy with?
        </span>
      </div>
      <textarea
        className="textarea"
        placeholder="The take-home takes two weekends and we still can't tell if they wrote it…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={4}
      />
      {followupStatus === "error" && error ? (
        <div className="waitlist-form__error" role="alert">
          {error}
        </div>
      ) : null}
      <div className="post-submit__actions">
        <button type="button" className="post-submit__skip" onClick={() => setSkipped(true)}>
          Skip
        </button>
        <Button type="submit" variant="primary" disabled={submitting || text.trim().length === 0}>
          {submitting ? "Sending…" : "Send"}
        </Button>
      </div>
    </form>
  );
}
